import {modelsWithJsonSchemaSupport, o1ModelNames, publishersWithStructuredOutputSupport} from './playground-types'

// TODO: This entire file needs to be migrated to a more dynamic way of setting these capabilities
// ref: https://github.com/github/models/issues/1898

export function supportsStructuredOutput(model: {name: string; publisher: string}) {
  const modelName = model.name.toLowerCase()

  // o1 models currently don't support structured output at all
  if (o1ModelNames.includes(modelName)) {
    return false
  }

  // all models 'support' JSON output, but some of them are not trained on enough JSON
  // to be able to actually do it without spinning forever and outputting \n tokens
  const publisher = model.publisher.toLowerCase()
  if (publishersWithStructuredOutputSupport.includes(publisher)) {
    return true
  }

  return false
}

export function supportsJsonSchemaStructuredOutput(model: {name: string}) {
  const modelName = model.name.toLowerCase()

  return modelsWithJsonSchemaSupport.includes(modelName)
}

export function supportsStreamingOptions(model: {publisher: string}): boolean {
  return model.publisher.toLowerCase() === 'openai'
}
